import { createContext } from 'react';

/**
 * ModalDirtyContext — shared between Modal (provider) and CrudForm (consumer).
 *
 * Modal creates the isDirty state and passes setIsDirty down via this context.
 * CrudForm calls setIsDirty when its own dirty state changes.
 * Modal reads its local isDirty to guard X / Escape / backdrop close.
 *
 * Default no-ops so CrudForm works safely outside a Modal too.
 */
const ModalDirtyContext = createContext({
  setIsDirty: () => {},
});

export default ModalDirtyContext;
